import {Component} from 'react';

import CreatableSelect from 'react-select/creatable';
import { FieldConnect } from 'react-components-form';
import {withTranslation} from "react-i18next";
import ErrorField from '../ErrorField/ErrorField';
import { shouldFieldUpdate } from '../shouldFieldUpdate';
import {limitOptions} from './limitOptions';

class CreatableSelectField extends Component {

    constructor(props) {
        super(props);

        //Mudeli väärtus (option-objekt) kohe esimesel renderdusel - muidu jääb uuesti mountitud väli (nt TSK2-536
        //materjalirea Värvitoon pärast salvestamist) tühjaks, kuni mõni prop juhuslikult muutub
        const modelOption = props.value && typeof props.value === 'object' ? props.value : undefined;
        this.state = {selectedOptions: props.selectedOptions || modelOption, inputValue: ''};
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.selectedOptions !== this.state.selectedOptions
            || nextState.inputValue !== this.state.inputValue
            || shouldFieldUpdate(this.props, nextProps);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.selectedOptions){
            this.setState({selectedOptions: nextProps.selectedOptions});
        } else{
            this.setState({selectedOptions: nextProps.value});
        }
    }

    handleChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'create-option') {
            this.props.createValue(newValue);
        }
        if (!newValue || newValue.length === 0){
            if(this.props.isMulti){
                this.setState({selectedOptions: []});
                this.props.onChange([]);
                if (this.props.onChangeValue) this.props.onChangeValue([]);
            } else{
                this.setState({selectedOptions: {}});
                this.props.onChange({});
                if (this.props.onChangeValue) this.props.onChangeValue({});
            }
        } else if (newValue) {
            this.props.onChange(newValue.value);
            if(typeof this.props.onChanged === 'function'){
                this.props.onChanged(newValue, actionMeta);
            }
            if (this.props.onChangeValue) this.props.onChangeValue(newValue);
        }
    };

    handleInput = (newValue, actionMeta) => {
        if(actionMeta.action === "input-change"){
            this.setState({selectedOptions: null});
        }
        this.setState({inputValue: newValue});
        if (this.props.onInputChange) this.props.onInputChange(newValue);
    };

    render() {
        const {
            label,
            name,
            hasValidationError,
            errorStyles,
            validationErrors,
            isLoading,
            disabled,
            required,
            options,
            placeholder,
            t,
            isClearable,
            isMulti,
            isCreatable,
            createLabel,
            noOptionsLabel,
            maxOptions
        } = this.props;

        //Suurte nimekirjade puhul renderdame ainult maxOptions vastet, ülejäänud leiab trükkides
        const visibleOptions = maxOptions ? limitOptions(options, this.state.inputValue, maxOptions) : options;

        //Tühi option {} -> null, muidu näitab react-select tühja valitud väärtust placeholderi asemel
        const selected = this.state.selectedOptions && this.state.selectedOptions.constructor === Object
            && Object.keys(this.state.selectedOptions).length === 0 ? null : this.state.selectedOptions;

        return (
            <div className='mb-3'>
                {label && <label htmlFor={name}>
                    {label}
                    {required && <span className="text-danger"> *</span>}
                </label>}
                <CreatableSelect
                    classNamePrefix="react-select"
                    value={selected}
                    isClearable={isClearable}
                    onChange={this.handleChange}
                    onInputChange={(newValue, actionMeta) => {this.handleInput(newValue, actionMeta)}}
                    options={visibleOptions}
                    filterOption={maxOptions ? null : undefined}
                    placeholder={placeholder ? placeholder : t("fields.select")}
                    isLoading={isLoading}
                    isDisabled={disabled}
                    noOptionsMessage={() => {
                        return noOptionsLabel ? noOptionsLabel : t('fields.noOptions')
                    }}
                    formatCreateLabel={(inputValue) => {
                        return isCreatable === false
                            ? (t('fields.noOptions'))
                            : ((createLabel
                                ? createLabel
                                : t('grid.create')) + ': ' + inputValue);
                    }}
                    isMulti={isMulti}
                />
                {hasValidationError &&
                <small className="text-form text-danger">
                    <ErrorField errors={validationErrors} {...errorStyles} />
                </small>}
            </div>
        );
    }
}

export default FieldConnect(withTranslation('common')(CreatableSelectField));
